<template>
  <div class="p-inputgroup">
    <span class="p-inputgroup-addon">{{ label }}</span>
    <PrimeTextarea
      v-model="value"
      required="required"
      rows="rows"
      cols="cols"
      @input="oninput"
      @change="oninput"
      style="maxHeight:100px;height:100px;"
    />
  </div>
</template>


<script>
export default {
  props: ["modelValue", "label", "required",  "rows", "cols"],
  emits: ["update:modelValue"],

  data() {
    return {
      value: null,
    };
  },
  FAWMQ003service: null,
  created() {
    this.value = this.modelValue;
  },
  methods: {
    oninput() {
      this.$emit("update:modelValue", this.value);
    },
  },
};
</script>
